import axios from "axios";
import ErrorMessage from "../libs/helpers/ErrorMessage";
import Config from "../Config";
import { getFromLocalStorage } from "../libs/helpers/localstorage";

export const TAG_ENTITY = {
  COMPANY: "company",
  CONTACT: "contact",
  PITCH: "pitch",
  PITCH_SCORE: "pitchScore",
};

export const getTagsApi = async ({ headers } = {}) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag`,
    {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const getTagDetailApi = async ({ headers, id, pageNum, entity }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}?entity=${entity}&pageNum=${pageNum}`,
    {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const getTagCompanyDetailApi = async ({ headers, id, pageNum }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}?entity=company&pageNum=${pageNum}`,
    {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const getTagContactDetailApi = async ({ headers, id, pageNum }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}?entity=contact&pageNum=${pageNum}`,
    {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const createTagApi = async ({ headers, name, color }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag`,
    {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, color }),
    },
  );

  if (res.ok) {
    return;
  }

  const { status, statusText, httpStatus, clientType, description } = res;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const associateTagApi = async ({ headers, id, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}`,
    {
      method: "PUT",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    },
  );

  if (res.ok) {
    return;
  }

  const { status, statusText, httpStatus, clientType, description } = res;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const getAssociatedTagsApi = async ({ entity, entityIds }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/associations?entity=${entity}`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: entityIds }),
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const associationsTagIdCompanyApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/associations?entity=company`,
    {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
      body: JSON.stringify(data),
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const associationsTagIdContactApi = async ({ headers, data }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/associations?entity=contact`,
    {
      method: "POST",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
      body: JSON.stringify(data),
    },
  );

  const response = await res.json();

  if (res.ok) {
    return response;
  }
  const { statusText, status } = res;
  const { httpStatus, clientType, description } = response;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const deleteTagApi = async ({ headers, id }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}`,
    {
      method: "DELETE",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  if (res.ok) {
    return;
  }

  const { status, statusText, httpStatus, clientType, description } = res;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const exportTagCompaniesApi = async ({ headers, id }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}/companies/export`,
    {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  const response = await res.blob();

  if (res.ok) {
    return response;
  }

  const { status, statusText, httpStatus, clientType, description } = res;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const exportTagContactsApi = async ({ headers, id }) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${id}/contacts/export`,
    {
      method: "GET",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  const response = await res.blob();

  if (res.ok) {
    return response;
  }

  const { status, statusText, httpStatus, clientType, description } = res;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const deleteAssociatedIdTagApi = async ({
  headers,
  tagId,
  associatedId,
}) => {
  const ls = getFromLocalStorage();
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const token = ls && ls.token;
  const res = await fetch(
    `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${tagId}/${associatedId}`,
    {
      method: "DELETE",
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
        "x-tenant": tenant,
      },
    },
  );

  if (res.ok) {
    return;
  }

  const { status, statusText, httpStatus, clientType, description } = res;
  throw new ErrorMessage(
    statusText,
    description,
    httpStatus,
    status,
    clientType,
  );
};

export const attachTagToCompanySearchApi = async ({ headers, tagId, data }) => {
  if (data.creation_year) {
    if (Array.isArray(data.creation_year)) {
      data.creation_year = data.creation_year.map((y) => parseInt(y, 10));
    } else {
      data.creation_year = parseInt(data.creation_year, 10);
    }
  }
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const ls = getFromLocalStorage();
  const token = ls && ls.token;
  try {
    const res = await axios.put(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${tagId}/company-search`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};

export const attachTagToContactSearchApi = async ({ headers, tagId, data }) => {
  if (data.company_filters?.creation_year) {
    if (Array.isArray(data.company_filters.creation_year)) {
      data.company_filters.creation_year = data.company_filters.creation_year.map((y) => parseInt(y, 10));
    } else {
      data.company_filters.creation_year = parseInt(data.company_filters.creation_year, 10);
    }
  }

  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const ls = getFromLocalStorage();
  const token = ls && ls.token;
  try {
    const res = await axios.put(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${tagId}/contact-search`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};

export const attachTagToPitchSearchApi = async ({ headers, tagId, data }) => {
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const ls = getFromLocalStorage();
  const token = ls && ls.token;
  try {
    const res = await axios.put(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${tagId}/pitch-search`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};

export const attachTagToPitchScoresSearchApi = async ({
  headers,
  tagId,
  data,
}) => {
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const ls = getFromLocalStorage();
  const token = ls && ls.token;
  try {
    const res = await axios.put(
      `${Config.apiBaseurl}/${Config.apis.frontend.api}/tag/${tagId}/pitch-score-search`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant": tenant,
          ...headers,
        },
      },
    );

    return res.data;
  } catch (e) {
    if (e.response) {
      const { statusText, status } = e.response;
      const { httpStatus, clientType, description } = e.response.data;
      throw new ErrorMessage(
        statusText,
        description,
        httpStatus,
        status,
        clientType,
      );
    } else throw e;
  }
};
